module.exports = "/static/assets/b4b0b568e40b4296d473ed4906cb9fd7.png";